// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const WALL_GROWL_SUBSCRIBED_TO_CONTEST_ANNOUNCEMENT = "Upozornenia <strong>zapnut\u00e9</strong>. Odteraz \u0165a budeme informova\u0165 o nov\u00fdch s\u00fa\u0165a\u017eiach.";
export const WALL_GROWL_UNSUBSCRIBED_FROM_CONTEST_ANNOUNCEMENT = "Upozornenia <strong>vypnut\u00e9</strong>. U\u017e \u0165a nebudeme informova\u0165 o nov\u00fdch s\u00fa\u0165a\u017eiach.";
